export enum BONUSX_SUBSCRIPTION_TIERS {
  FREE = "FREE",
  TIER_1 = "BASIC",
  TIER_2 = "PREMIUM",
  TIER_3 = "GOLD",
}

export const BONUSX_SUBSCRIPTION_TIER_TO_GENERAL_SUBSCRIPTION_TIER_MAP = {
  [BONUSX_SUBSCRIPTION_TIERS.FREE]: "Free",
  [BONUSX_SUBSCRIPTION_TIERS.TIER_1]: "Base",
  [BONUSX_SUBSCRIPTION_TIERS.TIER_2]: "Premium",
  [BONUSX_SUBSCRIPTION_TIERS.TIER_3]: "Gold",
};

export const GENERAL_SUBSCRIPTION_TO_BONUSX_SUBSCRIPTION_TIER_MAP: Record<string, BONUSX_SUBSCRIPTION_TIERS> = {
  Free: BONUSX_SUBSCRIPTION_TIERS.FREE,
  Base: BONUSX_SUBSCRIPTION_TIERS.TIER_1,
  Premium: BONUSX_SUBSCRIPTION_TIERS.TIER_2,
  Gold: BONUSX_SUBSCRIPTION_TIERS.TIER_3,

  // TODO -> remove together with the feature flag for the flexible structure
  FREE: BONUSX_SUBSCRIPTION_TIERS.FREE,
  BASIC: BONUSX_SUBSCRIPTION_TIERS.TIER_1,
  PREMIUM: BONUSX_SUBSCRIPTION_TIERS.TIER_2,
  GOLD: BONUSX_SUBSCRIPTION_TIERS.TIER_3,
};
